import { Component, Host, Prop, h } from '@stencil/core';

@Component({
  tag: 'cradlepoint-button-cta',
  styleUrl: 'button-cta.css',
  shadow: true,
})

export class ButtonCta {
  @Prop() textColor: string = 'white';
  @Prop() textColorHover: string = 'var(--cwc-color-secondary-900, #242424)';
  @Prop() backgroundColor: string = this.textColorHover;
  @Prop() backgroundColorHover: string = this.textColor;
  @Prop() borderColor: string = this.backgroundColor;
  @Prop() borderColorHover: string = this.borderColor;
  @Prop() fontSize: string = '1rem';
  @Prop() link: string = '#';
  @Prop() target: string;
  @Prop() download: boolean;

  render() {
    return (
      <Host>
        <style>{`
          :host {
            color: ${this.textColor};
            background-color: ${this.backgroundColor};
            border: 2px solid ${this.borderColor};
            font-size: ${this.fontSize} !important;
            width: auto !important;
          }

          :host(:hover) {
            color: ${this.textColorHover};
            background-color: ${this.backgroundColorHover};
            border: 2px solid ${this.borderColorHover};
          }

          :host::before {
            background: ${this.borderColor}
          }
        `}</style>
        <a
          href={ this.link }
          target={ this.target }
          download={ this.download }
        >
          <slot></slot>
        </a>
      </Host>
    );
  }
}
